import React from "react";

import { StyledSVG } from "../StyledIcon";

export const BeachIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <path
        d="M40 54C33.9843 50.7004 21.9529 39.281 21.9529 20C17.2263 27.8903 13.7028 45.7367 21.9529 54"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44 27C44 24.2872 43.0808 21.6545 41.3924 19.5312C39.704 17.4079 37.3459 15.9194 34.7029 15.3084C32.0598 14.6973 29.2877 14.9999 26.8387 16.1667C24.3897 17.3335 22.4082 19.2956 21.2176 21.7332"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 21C25.5 19.5 35.6 18.6 44 27"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.8535 8.35811C32.24 7.3729 30.3403 6.96344 28.4643 7.19653C26.5882 7.42962 24.8465 8.2915 23.5232 9.6416C22.1999 10.9917 21.373 12.7503 21.1776 14.6307C20.9821 16.511 21.4295 18.4022 22.4469 19.9956"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1134 19.5612C22.6739 16.6373 25.8068 10.3033 33.8535 8.35796"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 24C7 22.1915 7.61278 20.4363 8.7384 19.0208C9.86401 17.6053 11.436 16.6129 13.1981 16.2056C14.9601 15.7982 16.8082 15.9999 18.4409 16.7778C20.0736 17.5556 21.3945 18.8638 22.1883 20.4888"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 20.5624C19.3333 19.7029 12.6 19.1873 7 24"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 54.5H34.5"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 54L47 54"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 54L52 54"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39 38C39 36.4087 39.6321 34.8826 40.7574 33.7574C41.8826 32.6321 43.4087 32 45 32C46.5913 32 48.1174 32.6321 49.2426 33.7574C50.3679 34.8826 51 36.4087 51 38C51 39.5913 50.3679 41.1174 49.2426 42.2426C48.1174 43.3679 46.5913 44 45 44C43.4087 44 41.8826 43.3679 40.7574 42.2426C39.6321 41.1174 39 39.5913 39 38L39 38Z"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
